<template>
  <div>
    <loading-content v-if="!allLoaded"/>
    <div v-else>
      <div v-if="!hasClaim">{{ translations.details.section_remit_information.no_claim }}</div>
      <div v-else>
        <div v-if="remits.length">
          <financial-list
            :value="1"
            :header-data="REMITS_TABLE_HEADERS"
            :data="remits"
            :havePagination="false"
            noItemsMessage=""/>
          <div class="net-payment">{{ translations.details.section_remit_information.net_payment }} {{formatValue(totalNetPayment)}}</div>
        </div>
        <div v-else>{{ translations.details.section_remit_information.no_remits }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import translations from '@/translations';
import { formatDate, formatValue } from '@/helpers/finance';
import { parseResponseError } from '@/http/parsers/parse_response';
import LoadingContent from '@/components/LoadingContent.vue';
import service from '@/services/finance-service';
import errorHandler from '@/mixins/errorHandler';
import FinancialList, { associateHeaderDataItem } from '@/components/Financial/FinancialList.vue';

export default {
  name: 'DetailsSectionRemitInformation',
  components: {
    FinancialList,
    LoadingContent,
  },
  mixins: [ errorHandler ],
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      translations: translations.finance_operations.claims_follow_up_tasks,
      allLoaded: false,
      hasClaim: true,
      remits: [],
      totalNetPayment: 0,
    };
  },
  created() {
    const sectionT = this.translations.details.section_remit_information;
    this.REMITS_TABLE_HEADERS = [
      associateHeaderDataItem(sectionT.table_header_sword_claim_id, 'sword_claim_id'),
      associateHeaderDataItem(sectionT.table_header_payer_name, 'payer_name'),
      associateHeaderDataItem(sectionT.table_header_payer_claim_id, 'payer_claim_id'),
      associateHeaderDataItem(sectionT.table_header_payment_date, 'payment_date'),
      associateHeaderDataItem(sectionT.table_header_paid_amount, 'paid_amount'),
      associateHeaderDataItem(sectionT.table_header_check_number, 'check_number'),
    ];
  },
  async beforeMount() {
    this.hasClaim = this.details.claim?.id > 0;
    let loaded = true;
    if (this.hasClaim) {
      loaded = await this.fetchRemits();
    }
    if (loaded) {
      this.allLoaded = true;
    }
  },
  methods: {
    formatValue,
    async fetchRemits() {
      try {
        const response = await service.getClaimRemits(this.details.claim.id);
        this.remits = response?.data?.remits || [];
        this.totalNetPayment = 0;
        this.remits.map(r => {
          this.totalNetPayment += r.paid_amount;

          r.payment_date = formatDate(r.payment_date);
          r.paid_amount = formatValue(r.paid_amount);
          return r;
        });
        return true;
      } catch (err) {
        this.$noty.error(`${this.translations.errors.fetch_remits}: ${parseResponseError(err)}`);
        return false;
      }
    },
  },
};
</script>

<style scoped>
.net-payment {
  text-align: center;
}
</style>
